import React, {useEffect} from 'react';
import {Grid} from '@material-ui/core';
import InputField from "../../../../FormikUtils/InputField";
import SelectField from "../../../../FormikUtils/SelectField";
import {useFormikContext} from 'formik'
import SlantedField from "../../../../FormikUtils/SlantedField";

export default function ClienteForm(props) {
    const {values, setFieldValue, setTouched} = useFormikContext();
    const {
        formField: {
            dni,
            cuit,
            fechaNacimiento,
            sexo,
        },
        rowData
    } = props;

    const opcionesSexo = [
        {value: '1', label: 'Femenino'},
        {value: '2', label: 'Masculino'}
    ];

    function CuitGenerator(dni, gender) {
        let genderNumber = gender === '2' ? 20 : 27;

        const generateverificator = () => {
            const multipliers = [2, 3, 4, 5, 6, 7];
            const genderNumberAndDNI = `${genderNumber}${dni}`;

            let total = 0;
            let multpIndex = 0;
            for (let i = String(genderNumberAndDNI).length - 1; i > -1; i--) {
                const sum = genderNumberAndDNI[i] * multipliers[multpIndex];
                total += sum;
                if (multpIndex === 5) multpIndex = 0;
                else multpIndex += 1;
            }

            const verificator = 11 - (total % 11);
            if (verificator === 10) {
                genderNumber = 23;
                return generateverificator();
            }
            if (verificator === 11) return 0;
            return verificator;
        };
        const verificator = generateverificator();

        return `${genderNumber}${dni}${verificator}`

    }

    useEffect(() => {
        let cuit = CuitGenerator(rowData.Clientes.DNI, values.sexo)
        setFieldValue('cuit', cuit)
        setTouched({})
    }, [values.sexo]);

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <SelectField
                        name={sexo.name}
                        label={sexo.label}
                        data={opcionesSexo}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <SlantedField value={rowData.Clientes.DNI}
                                  label={dni.label}/>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <SlantedField value={values.cuit}
                                  label={cuit.label}/>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <InputField
                        name={fechaNacimiento.name}
                        label={fechaNacimiento.label}
                        type="date"
                        fullWidth
                        InputLabelProps={{shrink: true}}
                        textTransform={'lowercase'}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}